interface NormalObject {
  [key: string]: unknown;
}

export const isObject = (value: unknown): value is NormalObject => {
  return value instanceof Object;
};
